import { RECEIVE_DASHBOARD_DATA } from './constants';

const initialState = {
  data: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case RECEIVE_DASHBOARD_DATA:
      return { ...state, data: action.payload };
    default:
      return state;
  }
};

export default reducer;
